import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as notificationService from "../../services/notificationService";

// Async thunk to fetch notifications
export const fetchNotifications = createAsyncThunk(
  "notifications/fetchNotifications",
  async (params = {}, thunkAPI) => {
    try {
      const response = await notificationService.getNotifications(params);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Async thunk to add notification
export const addNotificationAsync = createAsyncThunk(
  "notifications/addNotification",
  async (notificationData, thunkAPI) => {
    try {
      const response = await notificationService.addNotification(
        notificationData
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Async thunk to delete notification
// export const deleteNotification = createAsyncThunk(
//   "notifications/deleteNotification",
//   async (id, thunkAPI) => {
//     try {
//       const response = await notificationService.deleteNotificationById(id);
//       return response;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// Async thunk to update notification status
// export const updateNotificationStatus = createAsyncThunk(
//   "notifications/updateNotificationStatus",
//   async ({ id, statusObj }, thunkAPI) => {
//     try {
//       const response = await notificationService.updateNotificationStatusById(
//         id,
//         statusObj
//       );
//       return response;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
  list: [],
  pagination: {},
  total: 0,   // ADD
  page: 1,    // ADD
  status: { list: "idle", add: "idle", delete: "idle", updateStatus: "idle" },
  error: null,
},
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch notifications
      .addCase(fetchNotifications.pending, (state) => {
        state.status.list = "loading";
      })
     .addCase(fetchNotifications.fulfilled, (state, action) => {
  state.status.list = "succeeded";
  state.list = action.payload.data;           // your data array
  state.pagination = action.payload.pagination;
  state.total = action.payload.pagination?.total || 0;  // ADD
  state.page = action.payload.pagination?.page || 1;    // ADD
})
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.status.list = "failed";
        state.error = action.payload;
      })

      // Add notification
      .addCase(addNotificationAsync.pending, (state) => {
        state.status.add = "loading";
      })
      .addCase(addNotificationAsync.fulfilled, (state, action) => {
        state.status.add = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(addNotificationAsync.rejected, (state, action) => {
        state.status.add = "failed";
        state.error = action.payload;
      })

      // Delete notification
      // .addCase(deleteNotification.pending, (state) => {
      //   state.status.delete = "loading";
      // })
      // .addCase(deleteNotification.fulfilled, (state, action) => {
      //   state.status.delete = "succeeded";
      //   state.list = state.list.filter((item) => item._id !== action.meta.arg);
      // })
      // .addCase(deleteNotification.rejected, (state, action) => {
      //   state.status.delete = "failed";
      //   state.error = action.payload;
      // })

      // Update notification status
      // .addCase(updateNotificationStatus.pending, (state) => {
      //   state.status.updateStatus = "loading";
      // })
      // .addCase(updateNotificationStatus.fulfilled, (state, action) => {
      //   state.status.updateStatus = "succeeded";
      //   const index = state.list.findIndex(
      //     (item) => item._id === action.meta.arg.id
      //   );
      //   if (index !== -1) {
      //     state.list[index].status = action.meta.arg.statusObj.status;
      //   }
      // })
      // .addCase(updateNotificationStatus.rejected, (state, action) => {
      //   state.status.updateStatus = "failed";
      //   state.error = action.payload;
      // });
  },
});

// export const selectNotifications = (state) => state.notifications.list;
export const selectNotifications = (state) =>
  Array.isArray(state.notifications.list) ? state.notifications.list : [];

export const selectNotificationsPagination = (state) => state.notifications.pagination;

export const selectNotificationStatus = (state) => state.notifications.status;

export default notificationSlice.reducer;
